import React, { Component } from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import pcWrap from './container/pc/Wrap';
import mWrap from './container/m/Wrap';
import { isMobileDevice } from './constants';
import 'isomorphic-fetch';

class App extends Component {
  render () {
    return (
      <Router basename='/roulette/index.html'>
        <Switch>
          <Route exact path='/' component={isMobileDevice ? mWrap : pcWrap} />
        </Switch>
      </Router>
    );
  }
}

export default App;
